/*
 * findPos
 *
 * Finds the position of an object in the DOM
 */
const findPos = (element) => {
  const viewportOffset = element.getBoundingClientRect();
  return [viewportOffset.top];
};

export default findPos;
